import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const CATEGORIES = ["Lingkungan", "Pendidikan", "Sosial & Kesehatan", "Pemberdayaan", "Sosial/Gender", "Kemiskinan", "Darurat"];
export const FORMATS = ["Offline", "Online", "Hybrid"];
export const CITIES = ["Jakarta", "Bogor", "Garut"];

export const CATEGORY_STYLES = {
  Lingkungan: "bg-emerald-100 text-emerald-800",
  Pendidikan: "bg-sky-100 text-sky-800",
  "Sosial/Gender": "bg-violet-100 text-violet-800",
  Kemiskinan: "bg-amber-100 text-amber-800",
  Darurat: "bg-rose-100 text-rose-800",
  "Sosial & Kesehatan": "bg-orange-100 text-orange-800",
  Pemberdayaan: "bg-fuchsia-100 text-fuchsia-800",
};

export const STATUS_STYLES = {
  Active: "bg-emerald-600 text-white",
  Full: "bg-slate-400 text-white",
  Upcoming: "bg-teal-100 text-teal-800",
  Selesai: "bg-slate-900 text-white",
};
